import { useMemo } from 'react';

interface ThemeColors {
  boundingBox: {
    primary: string;
    borderPrimary: string;
    muted: string;
  };
}

export function useThemeColors(): ThemeColors {
  return useMemo(() => {
    const styles = getComputedStyle(document.documentElement);

    return {
      boundingBox: {
        primary: styles.getPropertyValue('--bounding-box-primary').trim(),
        borderPrimary: styles
          .getPropertyValue('--bounding-box-border-primary')
          .trim(),
        muted: styles.getPropertyValue('--bounding-box-muted').trim(),
      },
    };
  }, []);
}
